import { FC, PropsWithChildren, useState } from 'react';
import { flushSync } from 'react-dom';
import { HealthCenterContext } from './HealthCenterContext';
import { HealthCenterConfig } from './types';

export const HealthCenterProvider: FC<PropsWithChildren> = ({ children }) => {
  const [healthCenterConfig, setHealthCenterConfig] = useState<HealthCenterConfig>(
    localStorage.getItem('healthCenterConfig')
      ? JSON.parse(localStorage.getItem('healthCenterConfig') as string)
      : { id: '', key: '' }
  );

  const value = {
    healthCenterConfig,
    storeHealthCenterConfig: (config: HealthCenterConfig) => {
      localStorage.setItem('healthCenterConfig', JSON.stringify(config));
      flushSync(() => setHealthCenterConfig(config));
    },
    resetHealthCenterConfig: () => {
      localStorage.removeItem('healthCenterConfig');
      flushSync(() => setHealthCenterConfig({ id: '', key: '' }));
    },
  };

  return <HealthCenterContext.Provider value={value}>{children}</HealthCenterContext.Provider>;
};
